import { render, staticRenderFns } from "./shetuzidian.vue?vue&type=template&id=09e7d6c0&"
import script from "./shetuzidian.vue?vue&type=script&lang=ts&"
export * from "./shetuzidian.vue?vue&type=script&lang=ts&"
import style0 from "./shetuzidian.vue?vue&type=style&index=0&id=09e7d6c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports